import { render, staticRenderFns } from "./content_top.vue?vue&type=template&id=745a7b32&scoped=true&"
import script from "./content_top.vue?vue&type=script&lang=js&"
export * from "./content_top.vue?vue&type=script&lang=js&"
import style0 from "./content_top.vue?vue&type=style&index=0&id=745a7b32&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745a7b32",
  null
  
)

export default component.exports